import React from 'react';
import { Row, Col, Button } from 'antd';
import * as Config from '../../Config';

const LogoutButton = () => {
    return (
        <div>
            <Row>
                <Col
                    xs={24}
                    align='center'
                    style={{
                        padding: '0.5rem 0 0.5rem 0',
                    }}
                >
                    <Button
                        block
                        onClick={async () => {
                            try {
                                await fetch('https://api.rajchandra.me/identity/auth/logout', { method: 'POST', credentials: 'include' });
                            } catch (e) {
                                console.error(e);
                            }
                            window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(window.location.origin)}`;
                        }}
                    >
                        Logout
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default LogoutButton;
